import React, {useContext} from "react";
import Headroom from "react-headroom";
import "./Header.scss";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import StyleContext from "../../contexts/StyleContext";
import {greeting} from "../../portfolio";

function Header() {
  const {isDark, currentPage, setCurrentPage} = useContext(StyleContext);

  return (
    <Headroom>
      <header className={isDark ? "dark-menu header" : "header"}>
        <a href="/" className="logo">
          <span className="grey-color"> &lt;</span>
          <span className="logo-name">{greeting.username}</span>
          <span className="grey-color">/&gt;</span>
        </a>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{color: "white"}}
        >
          <span className={isDark ? "navicon navicon-dark" : "navicon"}></span>
        </label>
        <ul className={isDark ? "dark-menu menu" : "menu"}>
          <li>
            <button 
              className={currentPage === "home" ? "active" : ""}
              onClick={() => setCurrentPage("home")}
            >
              Home
            </button>
          </li>
          <li>
            <button 
              className={currentPage === "experience" ? "active" : ""}
              onClick={() => setCurrentPage("experience")}
            >
              Experiences
            </button>
          </li>
          <li>
            <button 
              className={currentPage === "blogs" ? "active" : ""}
              onClick={() => setCurrentPage("blogs")}
            >
              Blogs
            </button>
          </li>
          <li>
            <button 
              className={currentPage === "travels" ? "active" : ""}
              onClick={() => setCurrentPage("travels")}
            >
              Travels
            </button>
          </li>
          <li>
            <button 
              className={currentPage === "interests" ? "active" : ""}
              onClick={() => setCurrentPage("interests")}
            >
              Interests
            </button>
          </li>
          <li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>
              <ToggleSwitch />
            </a>
          </li>
        </ul>
      </header>
    </Headroom>
  );
}
export default Header;
